import PulseLoader from './PulseLoader.vue'
import GridLoader from './GridLoader.vue'
import ClipLoader from './ClipLoader.vue'
import RiseLoader from './RiseLoader.vue'
import BeatLoader from './BeatLoader.vue'
import SyncLoader from './SyncLoader.vue'
import RotateLoader from './RotateLoader.vue'
import FadeLoader from './FadeLoader.vue'
import PacmanLoader from './PacmanLoader.vue'
import SquareLoader from './SquareLoader.vue'
import ScaleLoader from './ScaleLoader.vue'
import SkewLoader from './SkewLoader.vue'
import MoonLoader from './MoonLoader.vue'
import RingLoader from './RingLoader.vue'
import BounceLoader from './BounceLoader.vue'
import DotLoader from './DotLoader.vue'

const VueSpinner = {
  PulseLoader,
  GridLoader,
  ClipLoader,
  RiseLoader,
  BeatLoader,
  SyncLoader,
  RotateLoader,
  FadeLoader,
  PacmanLoader,
  SquareLoader,
  ScaleLoader,
  SkewLoader,
  MoonLoader,
  RingLoader,
  BounceLoader,
  DotLoader
}

module.exports = VueSpinner




/** WEBPACK FOOTER **
 ** ./src/index.js
 **/